import { deactivate } from 'api/offers';
import { Actions as GlobalActions } from 'pages/_store/global/actions';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { messages } from '../EditOrderPage.translations';

export const useDeactivateOrder = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const call = async (publicId: string) => {
    try {
      await deactivate(publicId);
      dispatch(
        GlobalActions.sendNotification({
          message: formatMessage(messages.EditOrderPageOrderDeactivated),
          variant: 'success',
        })
      );
    } catch (e) {
      dispatch(
        GlobalActions.sendNotification({
          message: formatMessage(messages.EditOrderPageErrorDeactivatingTheOrder),
          variant: 'error',
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top',
          },
        })
      );
    }
  };

  return call;
};
